import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {COURIER_SERVICES_FOR_ORDER} from "../../queries/shipping";
import Form from "./RequestShippingQuoteForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelRequestShippingQuote} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {fromJS} from "immutable";

class RequestShippingQuoteFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      courierService: values.get("courierService")
    }
    return this.props.requestShippingQuote(updatedValues)
      .then((response) => {
        if (response.data.requestShippingQuote.errors.length <= 0) {
          this.props.cancelRequestShippingQuote();
        } else {
          let errors = createValidationErrors(response.data.requestShippingQuote.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRequestShippingQuote();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />    
    let courierServices = fromJS(data.availableCourierServicesForOrder);
    let defaultService = courierServices.filter(x => x.get("default") === true).first();
    // Get default courier
    // Set intialValues to default courierService
    let initialValues = fromJS({
      courierService: defaultService.get("service")
    })
    return (
      <Form
        errors={this.state.errors}
        message="Request a quote for the shipment?"
        initialValues={initialValues}
        courierServices={courierServices}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REQUEST_QUOTE = gql`
  mutation requestShippingQuote($data: RequestShippingQuoteInput!) {
    requestShippingQuote(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(COURIER_SERVICES_FOR_ORDER, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }
    })
  }),  
  graphql(REQUEST_QUOTE, {
    props: ({ mutate }) => ({
      requestShippingQuote: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRequestShippingQuote})(withMutation(RequestShippingQuoteFormContainer));